import PropTypes from 'prop-types';
import { FiArrowRight } from 'react-icons/fi';

import { Container, SeeAll, TitleGroup } from './styles';

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onActionClick: PropTypes.func,
};

const defaultProps = {
  description: null,
  actionLabel: null,
  onActionClick: null,
};

const SectionHead = ({ title, description, actionLabel, onActionClick }) => (
  <Container>
    <TitleGroup>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </TitleGroup>
    {actionLabel && onActionClick && (
      <SeeAll type="button" onClick={onActionClick}>
        {actionLabel}
        <FiArrowRight size={15} />
      </SeeAll>
    )}
  </Container>
);

SectionHead.propTypes = propTypes;
SectionHead.defaultProps = defaultProps;

export default SectionHead;
